// Generated by DesignToCode

import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./footer.html",
})
export class Footer {
  // Inputs
  public logoText = input<string>("fromScratch");
  public copyrightText = input<string>(`\u00a9 ${new Date().getFullYear()} fromScratch Studio`);
}
